import { Field } from 'react-final-form'
import { FinalFormTextArea } from '../TextArea'

export default function FormTextArea(props) {
  const { name } = props
  return <Field name={name} component={FinalFormTextArea} {...props} />
}
